/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * App.tsx - Entry point for app.
 */

import { StatusBar } from 'expo-status-bar';
import { useFonts } from 'expo-font';
import Navigation from './navigation';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import useSettingsStore from './hooks/useSettingsStore';
import { FakeSplash } from './components/FakeSplash';

const App = () => {
  const [fontsLoaded] = useFonts({
    WhiteRoseMathsFont: require('./assets/fonts/White_Rose_Noto_regular.ttf'),
  });

  const settingsStoreHasHydrated = useSettingsStore(settings => settings._hasHydrated);

  if (!fontsLoaded || !settingsStoreHasHydrated) {
    return null;
  }

  return (
    <SafeAreaProvider>
      <FakeSplash />
      <Navigation />
      <StatusBar translucent style='light'/>
    </SafeAreaProvider>
  );
};

export default App;
